/** Minimal silent MP3 used to unlock autoplay within a user gesture. */
const SILENT_MP3 =
  "data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAABhkVMmfIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+0DEAAAAAANIAAAAAAAAA0gAAAAAP/7UMQAAAAAAA0gAAAAAAAANIAAAAA//tQxAAAAAAAA0gAAAAAAAANIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAAAAAAAA0gAAAAAAAANIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAAAAAAAA0gAAAAAAAANIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";

export class PollyAudioPlayer {
  constructor() {
    this.audio = new Audio();
    this.blobUrl = null;
    this.rejectCurrent = null;
  }

  unlockAutoplay() {
    this.audio.src = SILENT_MP3;
    return this.audio.play().catch(() => {});
  }

  async playSegment(blob) {
    this.cleanupBlobUrl();
    this.blobUrl = URL.createObjectURL(blob);
    this.audio.src = this.blobUrl;

    await new Promise((resolve, reject) => {
      this.rejectCurrent = reject;
      let settled = false;

      const settle = (handler) => {
        if (settled) {
          return;
        }
        settled = true;
        this.rejectCurrent = null;
        this.clearAudioHandlers();
        handler();
      };

      this.audio.onended = () => settle(resolve);
      this.audio.onerror = (event) => settle(() => reject(event));
      this.audio.oncanplaythrough = () => {
        this.audio.play().catch((error) => settle(() => reject(error)));
      };
    });
  }

  stop() {
    this.clearAudioHandlers();
    this.audio.pause();
    this.audio.currentTime = 0;

    if (this.rejectCurrent) {
      this.rejectCurrent(new DOMException("Playback aborted", "AbortError"));
      this.rejectCurrent = null;
    }

    this.cleanupBlobUrl();
  }

  clearAudioHandlers() {
    this.audio.onended = null;
    this.audio.onerror = null;
    this.audio.oncanplaythrough = null;
  }

  cleanupBlobUrl() {
    if (!this.blobUrl) {
      return;
    }
    URL.revokeObjectURL(this.blobUrl);
    this.blobUrl = null;
  }
}
